import { SvgIcon } from '@mui/material';
import type { SvgIconProps } from '@mui/material/SvgIcon';

import type { IconType } from '../../types';

const IconName = 'Clipboard';

const IconSvg = `
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M7.5 3.75C7.5 3.33579 7.83579 3 8.25 3H15.75C16.1642 3 16.5 3.33579 16.5 3.75V4.5H18.75C19.1642 4.5 19.5 4.83579 19.5 5.25V20.25C19.5 20.6642 19.1642 21 18.75 21H5.25C4.83579 21 4.5 20.6642 4.5 20.25V5.25C4.5 4.83579 4.83579 4.5 5.25 4.5H7.5V3.75ZM7.5 6H6V19.5H18V6H16.5V6.75C16.5 7.16421 16.1642 7.5 15.75 7.5H8.25C7.83579 7.5 7.5 7.16421 7.5 6.75V6ZM15 6V4.5H9V6H15Z" fill="currentColor"/>
  </svg>
`;

const ClipboardIcon = (props: SvgIconProps) => (
  <SvgIcon viewBox='0 0 24 24' {...props}>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M7.5 3.75C7.5 3.33579 7.83579 3 8.25 3H15.75C16.1642 3 16.5 3.33579 16.5 3.75V4.5H18.75C19.1642 4.5 19.5 4.83579 19.5 5.25V20.25C19.5 20.6642 19.1642 21 18.75 21H5.25C4.83579 21 4.5 20.6642 4.5 20.25V5.25C4.5 4.83579 4.83579 4.5 5.25 4.5H7.5V3.75ZM7.5 6H6V19.5H18V6H16.5V6.75C16.5 7.16421 16.1642 7.5 15.75 7.5H8.25C7.83579 7.5 7.5 7.16421 7.5 6.75V6ZM15 6V4.5H9V6H15Z'
      fill='currentColor'
    />
  </SvgIcon>
);

export default {
  name: IconName,
  title: IconName,

  IconComponent: ClipboardIcon,
  IconSvg: IconSvg
} as IconType;
